import { render } from "./UnidadmedidaList.vue?vue&type=template&id=74c1106d&scoped=true"
import script from "./UnidadmedidaList.vue?vue&type=script&lang=js"
export * from "./UnidadmedidaList.vue?vue&type=script&lang=js"

import "./UnidadmedidaList.vue?vue&type=style&index=0&id=74c1106d&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c1106d"]])

export default __exports__